import React, { useState, useEffect } from 'react';
import { getAboutUs } from '../../../services/user/Settings.services';
import NoData from '../../../components/common/NoData';
import { getPrivacyPolicyUrl } from '../../../utils/legalUrls';


function AboutUs() {
  const [aboutUs, setAboutUs] = useState([]);
  const privacyPolicyUrl = getPrivacyPolicyUrl();

  useEffect(() => {
    getAboutUsData();
  }, []);

  const getAboutUsData = async () => {
    try {
      const response = await getAboutUs();
      if (response.success && response.data?.response) {
        setAboutUs(response.data.response);
      } else {
        setAboutUs([]);
      }
    } catch (error) {
      setAboutUs([]);
    }
  };

  return (
    <div className="max-[768px]:tw-p-[16px] about-us-container">
      <div className={"tw-mb-[24px] [&_h3]:tw-text-[18px] [&_h3]:tw-font-semibold [&_h3]:tw-text-[#333] [&_h3]:tw-mb-[8px] [&_p]:tw-text-[14px] [&_p]:tw-text-[#666] [&_p]:tw-m-0 max-[768px]:[&_h3]:tw-text-[20px] section-header"}>
        <h3>About Us</h3>
        <p>Learn more about our mission, values, and who we are</p>
      </div>

      <a
        className={"tw-flex tw-items-center tw-justify-between tw-gap-[16px] tw-p-[16px_0] tw-mb-[8px] tw-border-b-[1px] tw-border-solid tw-border-b-[#eee] tw-no-underline tw-text-[inherit] [&:hover_.about-us-title]:tw-text-[#0d6efd] about-us-legal-link"}
        href={privacyPolicyUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        <div>
          <div className="tw-text-[18px] tw-font-semibold tw-text-[#2e2e2e] max-[768px]:tw-text-[16px] about-us-title tw-mb-1">Privacy Policy</div>
          <div className="tw-text-[14px] tw-text-[#444] tw-leading-[1.6] max-[768px]:tw-text-[13px] about-us-description tw-mb-0">How we collect, use, and protect your data</div>
        </div>
        <span className="tw-text-[12px] tw-text-[#888] tw-whitespace-nowrap about-us-legal-link-hint">Opens in a new tab</span>
      </a>

      <div className="tw-mt-[16px] about-us-content">
        {aboutUs.length > 0 ? (
          aboutUs.map((item, index) => (
            <div className={"tw-p-[20px_0] tw-border-b-[1px] tw-border-solid tw-border-b-[#eee] [&:last-child]:tw-border-b-0 about-us-item"} key={index}>
              {/privacy/i.test(item.name || '') ? (
                <a
                  className={"tw-inline-block tw-no-underline [&:hover]:tw-text-[#0d6efd] tw-text-[18px] tw-font-semibold tw-text-[#2e2e2e] tw-mb-[6px] max-[768px]:tw-text-[16px] about-us-title about-us-item-link"}
                  href={privacyPolicyUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {item.name}
                </a>
              ) : (
                <div className="tw-text-[18px] tw-font-semibold tw-text-[#2e2e2e] tw-mb-[6px] max-[768px]:tw-text-[16px] about-us-title">{item.name}</div>
              )}
              <div className="tw-text-[14px] tw-text-[#444] tw-leading-[1.6] max-[768px]:tw-text-[13px] about-us-description">{item.description}</div>
            </div>
          ))
        ) : (
          <NoData message="No About Us content available." />
        )}
      </div>
    </div>
  );
}

export default AboutUs;
